import React from 'react';
import { Card } from '../../common';
import { Table, Tag } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { formatNumberWithCommas } from '../../../utils/numbers';
import styles from './styles/reports-table.module.scss';

function ReportsUsersTable({ rows, loading, navigateUser }) {
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            render: (text, record) => (
                <Link onClick={() => navigateUser(record.id)} style={{ color: '#4285f4' }}>
                    {text}
                </Link>
            )
        },
        {
            title: 'Enrollment',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 150,
            render: (text) => <p>{moment(text).format('MMMM Do, YYYY')}</p>
        },
        {
            title: 'Total Advanced',
            dataIndex: 'totalAdvanced',
            key: 'totalAdvanced',
            width: 150,
            render: (text) => <p>${formatNumberWithCommas(text, true)}</p>
        },
        {
            title: 'Status',
            dataIndex: 'hasActivity',
            key: 'hasActivity',
            width: 150,
            render: (text, record) => {
                // Determine status based on hasActivity
                const status = text ? 'Active' : 'Default';
                const color = text ? 'green' : 'default';
                return <Tag color={color}>{status}</Tag>;
            }
        },
        {
            title: 'Action',
            key: 'action',
            width: 150,
            render: (text, record) => <Link style={{ color: '#ff4d4f' }}>Restrict Access</Link>
        }
    ];

    return (
        <Card>
            <div className={styles.tableContainer}>
                <Table
                    rowSelection={{
                        type: 'checkbox'
                    }}
                    columns={columns}
                    dataSource={rows}
                    pagination={{ pageSize: 15 }}
                    loading={loading}
                    scroll={{ x: 'max-content' }}
                    className={styles.responsiveTable}
                    rowKey="id"
                />
            </div>
        </Card>
    );
}

export default ReportsUsersTable;
